import React from 'react';
import { observer } from 'mobx-react';
import dayjs from 'dayjs';
import { Column } from '@ant-design/charts';
import { Color } from '@app/themes/colors';
import { TIME_AND_DATE_FORMATS } from '@app/constants';
import { intervalFormatter } from '@app/utils/helpers';

declare type Props = {
  timeZoneOffset?: number;
  reportData: {
    elapsed: number;
    interval: Date;
  }[];
};

const Chart: React.FC<Props> = ({ reportData, timeZoneOffset }) => {
  const config = {
    data: reportData,
    height: 513,
    xField: 'interval',
    yField: 'elapsed',
    color: Color.red,
    label: {
      autoHide: true
      // content: function content(originData) {
      //   const elapsed = parseFloat(originData.elapsed);
      //   return null;
      // }
      // position: 'top',
      // content: function content({ interval }) {
      //   return interval.toFixed(1);
      // },
      // style: {
      //   fill: '#FFFFFF',
      //   opacity: 0.6
      // }
    },
    legend: false,
    slider: {
      start: 0,
      end: 1,
      formatter: intervalFormatter
    },
    meta: {
      interval: {
        alias: 'Hour',
        formatter: intervalFormatter
      },
      elapsed: {
        alias: 'kWh',
        formatter: kWh => {
          return kWh.toFixed(3);
        }
      }
    }
  };
  // @ts-ignore
  return <Column {...config} />;
};

export default observer(Chart);
